import { Box } from '@mui/material';
import { PricingSection } from '@/components/landing/PricingSection';

export function PricingPage() {
  return (
    <Box sx={{ bgcolor: '#050510' }}>
      <PricingSection />
    </Box>
  );
}
